import styled from "styled-components";

export const LoadingIcon = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 2.5rem;
`;

export const InstabilityBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  margin-top: 0.775rem;
  padding: 0.25rem 0.625rem;
  background: #d14624;
  border: 1px solid #ff3907;
  border-radius: 4px;
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: 500;
`;
